import { LocalStorage } from "wize-admin";

import { SecurityService } from "@/core/services";

const state = {
  accessToken: LocalStorage.getAccessToken(),
  user: LocalStorage.getUser(),
  ssoState: LocalStorage.getSsoState(),
  isTokenValid: false,
};

const getters = {
  isAuthenticated: (state) => state.user && (state.user.profile || state.user.role),
  getUser: (state) => state.user,
  getSsoState: (state) => state.ssoState,
  isTokenValid: (state) => state.isTokenValid,
  isAdmin: (state) => {
    const role = state.user?.role || state.user?.profile;
    return role === 'SUPER_ADMINISTRATOR' || role === 'ADMINISTRATOR';
  },
  isAffiliate: (state) => {
    const role = state.user?.role || state.user?.profile;
    return role === 'AFFILIATE';
  },
  affiliateId: (state) => state.user?.affiliate_id || null,
};

const actions = {
  setAccessToken({ commit }, payload) {
    commit("isTokenValid", true);
    commit("accessToken", payload);
  },
  checkValidToken({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      SecurityService.isValidToken()
        .then((response) => {
          if (response) {
            commit("isTokenValid", true);
            resolve();
          }
        })
        .catch((err) => {
          reject(err);
          dispatch("logout");
        });
    });
  },
  setUser({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      SecurityService.getUserInfo()
        .then((resp) => {
          let user = { ...resp.payload };
          user.name = `${user.first_name} ${user.last_name}`;
          user.fullName = user.name;
          // Normalize role <-> profile for compatibility
          if (user.role && !user.profile) user.profile = user.role;
          if (user.profile && !user.role) user.role = user.profile;
          commit("user", user);
          resolve(user);
        })
        .catch((ex) => {
          console.error(ex);
          dispatch("logout");
          reject();
        });
    });
  },
  setAuthInfo({ commit }, payload) {
    const { accessToken, user } = payload;
    commit("accessToken", accessToken);
    commit("user", user);
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      commit("accessToken", null);
      commit("user", null);
      resolve();
      window.location.href = process.env.VUE_APP_WEB_URL;
    });
  },
};

const mutations = {
  isTokenValid(state, value) {
    state.isTokenValid = value;
  },
  accessToken(state, value) {
    value ? LocalStorage.setAccessToken(value) : LocalStorage.clearAccessToken();
    state.accessToken = value;
  },
  user(state, value) {
    value ? LocalStorage.setUser(value) : LocalStorage.clearUser();
    state.user = value;
  },
  ssoState(state, value) {
    value ? LocalStorage.setSsoState(value) : LocalStorage.clearSsoState();
    state.ssoState = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
